var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 180
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-match_svg__a",
    x1: "90.95%",
    x2: "10.435%",
    y1: "20.843%",
    y2: "66.868%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A8BAE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-match_svg__b",
    x1: "79.256%",
    x2: "22.964%",
    y1: "82.884%",
    y2: "11.047%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A8BAE0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-match_svg__a)",
    d: "M89.205 31.63a28.038 28.038 0 01-22.02 15.983l-23.59 2.876C12.389 53.226 0 78.452 0 96.329c0 11.92 4.13 20.21 12.388 24.871h130.14c6.247 0 7.657-2.486 8.49-5.973 4.516-18.897 4.516-39.596-1.118-57.2a21.66 21.66 0 007.111-25.857L143.976 1.254c-.558-1.326-2.336-1.56-3.218-.423l-5.092 6.574a6.196 6.196 0 01-4.897 2.399H116.62a6.195 6.195 0 01-4.927-2.44L106.648.74a1.88 1.88 0 00-3.192.329L89.205 31.63z",
    transform: "translate(41 18)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-match_svg__b)",
    fillRule: "nonzero",
    d: "M0 98.2c0 7.457 2.72 13.752 7.705 19.08 3.449 3.685 7.065 6.27 13.881 10.447.342.209 1.945 1.188 2.382 1.457 11.774 7.221 15.38 11.283 15.38 18.985a9 9 0 0018 0c0-8.788-2.945-16.137-8.417-22.303-3.896-4.388-8.044-7.421-15.552-12.026-.454-.279-2.062-1.26-2.388-1.46C20.818 106.144 18 103.132 18 98.2a9 9 0 00-18 0z",
    transform: "translate(41 18)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#98B9FF",
    strokeLinecap: "square",
    strokeWidth: 4,
    d: "M161 76v-9a9 9 0 0118 0v41c0 16.569 13.431 30 30 30h91"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98B9FF",
    d: "M157 76h8a2 2 0 012 2v8h-12v-8a2 2 0 012-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#195DEE",
    d: "M159 86v3a1 1 0 01-2 0v-3h2zm6 0v3a1 1 0 01-2 0v-3h2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#195DEE",
    fillRule: "nonzero",
    d: "M153.647 124.745c3.936 0 6.898 2.031 8.353 5.218 1.414-3.098 4.252-5.104 8.026-5.213l.326-.005H177a1 1 0 01.116 1.994l-.116.007-6.907.003c-4.28.121-6.984 3.256-7.09 7.825l-.003.282v4.344h-2v-4.344c0-4.721-2.726-7.983-7.094-8.107l-6.906-.003a1 1 0 110-2h6.647zM169 134.2a1 1 0 011 1v4h-2v-4a1 1 0 011-1zm7 0a1 1 0 011 1v4h-2v-4a1 1 0 011-1zm-28 0a1 1 0 011 1v4h-2v-4a1 1 0 011-1zm7 0a1 1 0 011 1v4h-2v-4a1 1 0 011-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#195DEE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M153.837 44.757s1.49 3.074 6.21 3.074 6.207-3.074 6.207-3.074m-2.401 10.982s.745 1.538 3.105 1.538 3.106-1.538 3.106-1.538.743 1.538 3.103 1.538c2.36 0 3.106-1.538 3.106-1.538m-2.402-10.982s1.489 3.074 6.209 3.074 6.209-3.074 6.209-3.074"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#195DEE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.393 49.511l10.127-1.628m-10.146 8.925l10.166 1.37m-58.125-8.667l-10.127-1.628m10.146 8.925l-10.166 1.37"
  })))));
}
export default SvgNoMatch;